import React, { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { FormattedMessage } from 'react-intl';
import { reduxForm, Field, reset, initialize } from 'redux-form';
import {
  InputFieldComponent,
  TextareaFieldComponent,
} from '../../atoms/atoms.index';
import { useDispatch, useSelector } from 'react-redux';
import { required } from '../../../utils/FormValidators';
import { EFormName } from '../../../config/form-names.config';
import './NewEditWishModalForm.component.scss';
import { makeSelectForm } from '../../../store/form/form.selectors';
import moment from 'moment';
import { resetWish } from '../../../store/wishlist/wishlist.actions';
import { ImageUploaderComponent } from '../organisms.index';
import { EInput } from '../../../domain/input.interface';
import { IWish } from '../../../domain/wish.interface';
import {
  normalizeCurrency,
  formatNumberToCurrency,
  formatCurrencyToNumber,
} from '../../../utils/FormNormalizers';

function NewEditWishModalFormComponent(props: any) {
  const {
    showModal,
    handleClose,
    handleSubmit,
    propsWish,
    handleWishSubmit,
    handleNewImages,
    handleOldImages,
  } = props;
  const dispatch = useDispatch();
  const form = useSelector(makeSelectForm());
  const [trigger, setTrigger] = useState(false);
  const [isNewWish, setIsNewWish] = useState(true);
  const [wish, setWish] = useState<IWish>();
  const updatedAt = !!wish ? moment(wish.updatedAt).format('DD-MM-YYYY') : '';

  useEffect(() => {
    console.log('propsWish', propsWish);
    if (!!propsWish) {
      setIsNewWish(false);
      const formattedWish = !!propsWish.price
        ? { ...propsWish, price: formatNumberToCurrency(propsWish.price) }
        : { ...propsWish };
      setWish(formattedWish);
    }
    return () => {
      dispatch(resetWish());
      dispatch(reset(EFormName.NEW_WISH_GROUP));
    };
    // eslint-disable-next-line
  }, [propsWish]);

  useEffect(() => {
    dispatch(initialize(EFormName.NEW_WISH_GROUP, wish));
    // eslint-disable-next-line
  }, [wish]);

  const checkErrors = () => {
    return form[EFormName.NEW_WISH_GROUP].syncErrors ? true : false;
  };

  function resetModal() {
    dispatch(resetWish());
    dispatch(reset(EFormName.NEW_WISH_GROUP));
    handleClose();
  }

  return (
    <Modal
      className='new-wish-modal'
      show={showModal}
      onHide={() => resetModal()}
      size='xl'
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>
          <h2 className='new-wish-title in-modal'>
            {isNewWish ? (
              <FormattedMessage id='pages.new_wish_form.title_create' />
            ) : (
              <FormattedMessage id='pages.new_wish_form.title_modify' />
            )}{' '}
          </h2>
        </Modal.Title>
      </Modal.Header>
      <form
        name={EFormName.NEW_WISH_GROUP}
        onSubmit={handleSubmit((values: any) => {
          const formattedValues = !!values.price
            ? { ...values, price: formatCurrencyToNumber(values.price) }
            : { ...values };
          if (checkErrors()) {
            setTrigger(true);
            return;
          }
          if (!!wish) {
            handleWishSubmit(formattedValues, wish.id);
            resetModal();
            return;
          }
          resetModal();
          handleWishSubmit(formattedValues);
        })}
      >
        <Modal.Body>
          <div className='form-field-container'>
            <div>
              <h4 className='subtitle'>
                <FormattedMessage id='pages.new_wish_form.name.title' />
              </h4>
              <FormattedMessage id='pages.new_wish_form.name.placeholder'>
                {(txt: any) => (
                  <Field
                    name={'name'}
                    component={InputFieldComponent}
                    validate={[required]}
                    label={txt}
                    errorTrigger={trigger}
                  />
                )}
              </FormattedMessage>
            </div>
            <div>
              <h4 className='subtitle'>
                <FormattedMessage id='pages.new_wish_form.main_photo.title' />
              </h4>
              <div>
                <ImageUploaderComponent
                  name='main_photo'
                  handleNewImages={handleNewImages}
                  maxNumImg={1}
                  propsImages={!!wish && wish.mainPhoto}
                />
              </div>
            </div>
            <div>
              <h4 className='subtitle'>
                <FormattedMessage id='pages.new_wish_form.description.title' />
              </h4>
              <FormattedMessage id='pages.new_wish_form.description.placeholder'>
                {(txt: any) => (
                  <Field
                    name={'description'}
                    component={TextareaFieldComponent}
                    validate={[]}
                    label={txt}
                    errorTrigger={trigger}
                  />
                )}
              </FormattedMessage>
            </div>
            <div>
              <h4 className='subtitle'>
                <FormattedMessage id='pages.new_wish_form.url.title' />
              </h4>
              <div>
                <FormattedMessage id='pages.new_wish_form.url.placeholder'>
                  {(txt: any) => (
                    <Field
                      name={'url'}
                      component={InputFieldComponent}
                      validations={[]}
                      label={txt}
                      errorTrigger={trigger}
                    />
                  )}
                </FormattedMessage>
              </div>
            </div>
            <div>
              <h4 className='subtitle'>
                <FormattedMessage id='pages.new_wish_form.optional_photos.title' />
              </h4>
              <div>
                <ImageUploaderComponent
                  name='optional_photos'
                  handleNewImages={handleNewImages}
                  handleOldImages={handleOldImages}
                  maxNumImg={5}
                  propsImages={!!wish && wish.optionalPhotos}
                />
              </div>
            </div>
            <div>
              <h4 className='subtitle'>
                <FormattedMessage id='pages.new_wish_form.price.title' />
              </h4>
              <FormattedMessage id='pages.new_wish_form.price.placeholder'>
                {(txt: any) => (
                  <Field
                    name={'price'}
                    component={InputFieldComponent}
                    label={txt}
                    type={EInput.TEXT}
                    errorTrigger={trigger}
                    normalize={(value: number | string) =>
                      normalizeCurrency(value)
                    }
                  />
                )}
              </FormattedMessage>
            </div>
            <div>
              <h4 className='subtitle'>
                <FormattedMessage id='pages.new_wish_form.store.title' />
              </h4>
              <FormattedMessage id='pages.new_wish_form.store.placeholder'>
                {(txt: any) => (
                  <Field
                    name={'store'}
                    component={InputFieldComponent}
                    validate={[]}
                    label={txt}
                    errorTrigger={trigger}
                  />
                )}
              </FormattedMessage>
            </div>
            <div>
              <h4 className='subtitle'>
                <FormattedMessage id='pages.new_wish_form.notes.title' />
              </h4>
              <FormattedMessage id='pages.new_wish_form.notes.placeholder'>
                {(txt: any) => (
                  <Field
                    name={'notes'}
                    component={TextareaFieldComponent}
                    label={txt}
                    errorTrigger={trigger}
                  />
                )}
              </FormattedMessage>
            </div>
            {!isNewWish && (
              <div className='new-wish-uneditables'>
                <p className='text-primary-lg font-weight-light'>
                  <FormattedMessage id='pages.new_wish_form.status' />
                  {!!wish && (
                    <FormattedMessage
                      id={`common.wish.status_${wish.status}`}
                    />
                  )}
                </p>
                <p className='text-primary-lg font-weight-light'>
                  <FormattedMessage id='pages.new_wish_form.last_modified' />
                  {updatedAt}
                </p>
              </div>
            )}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button className='btn-lili danger' onClick={() => resetModal()}>
            <FormattedMessage id='common.cancel' />
          </button>
          <button className='btn-lili' type='submit'>
            <FormattedMessage id='pages.new_wish_form.save' />
          </button>
        </Modal.Footer>
      </form>
    </Modal>
  );
}

export default reduxForm({
  form: EFormName.NEW_WISH_GROUP,
})(NewEditWishModalFormComponent);
